import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles(theme => ({
  root: {
    width: 46,
    height: 23,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(23px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: theme.palette.common.black,
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: theme.palette.common.black,
      border: `6px solid ${theme.palette.common.black}`,
    },
  },
  thumb: {
    width: 21,
    height: 21,
  },
  track: {
    borderRadius: 23 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))
